import { Controller } from "@hotwired/stimulus"
import controller from "../utils/controller"

export default class extends Controller {
  static targets = ["title", "body", "cancel", "accept"]
  static values = { title: String, body: String, bodyHtml: String, cancel: String, accept: String }
  static classes = ["accept"]

  connect() {
    if (this.hasTitleValue) this.titleTarget.innerText = this.titleValue
    // `bodyHtml` carries our own locale copy, never user input, and exists so a
    // confirmation can link out — the terms and conditions prompt needs to.
    if (this.hasBodyHtmlValue) this.bodyTarget.innerHTML = this.bodyHtmlValue
    else if (this.hasBodyValue) this.bodyTarget.innerText = this.bodyValue
    if (this.hasCancelValue) this.cancelTarget.innerText = this.cancelValue
    if (this.hasAcceptValue) this.acceptTarget.innerText = this.acceptValue

    if (this.hasAcceptClass) this.acceptTarget.classList.add(...this.acceptClasses)

    this.modal.open()
  }

  cancel() {
    this.modal.close()
    this.dispatch("close", { detail: { confirmed: false } })
  }

  accept() {
    this.modal.close()
    this.dispatch("close", { detail: { confirmed: true } })
  }

  get modal() {
    return controller(this.element, "modal")
  }
}
